import script from "./gamePlayerRound.vue?vue&type=script&setup=true&lang=ts"
export * from "./gamePlayerRound.vue?vue&type=script&setup=true&lang=ts"

import "./gamePlayerRound.vue?vue&type=style&index=0&id=9c50eb4a&lang=css"

const __exports__ = script;

export default __exports__